import { render, staticRenderFns } from "./Donut.vue?vue&type=template&id=5d6ba8e0&scoped=true"
import script from "./Donut.vue?vue&type=script&lang=js"
export * from "./Donut.vue?vue&type=script&lang=js"
import style0 from "./Donut.vue?vue&type=style&index=0&id=5d6ba8e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6ba8e0",
  null
  
)

export default component.exports